const mailSubject = 'Learn How Cat Pain IQ Can Help You Prepare For Your Next Exam';
const defaultPrivacyPolicyLink = '[PRIVACY POLICY LINK]';
const defaultOptOutText = '[OPT OUT TEXT]';
const defaultOptOutLink = '[OPT OUT LINK]';

const generateInviteEmailSubject = () => encodeURI(mailSubject);

const generateInviteEmailBody = (org, encode = true) => {
  const privacyPolicyLink = org.privacy_policy_link
    ? org.privacy_policy_link
    : defaultPrivacyPolicyLink;
  const optOutText = org.general_opt_out_text ? org.general_opt_out_text : defaultOptOutText;
  const optOutLink = org.general_opt_out_link ? org.general_opt_out_link : defaultOptOutLink;

  const body = `Hi [CLIENT NAME]!

  We hope you and [CAT NAME] are doing well! As a way of preparing for your next appointment, we wanted to let you know about a new, free digital tool – Cat Pain IQ – that we're making available in partnership with Zoetis. This tool will help us work with you to recognize signs of osteoarthritis (OA) pain.

  OA pain isn't always obvious—its signs are subtle and can change over time. Because cats hide their pain by nature, we need your help watching [CAT NAME] at home.

  Cat Pain IQ can assist you by using a video you've taken. We encourage you to check it out at https://catpainiq.zoetispetcare.com?clinic_id=${org.id}. 

  Thank you
  ${org.name}


  Cat Pain IQ is not a medical diagnostic tool and is not intended to replace discussions with an animal healthcare professional. Discuss medical concerns with your veterinarian.

  This is an advertisement of ${org.name}

  ${org.address_1}
  ${org.city.name}, ${org.state.abbreviation} ${org.zipcode}

  Privacy Policy: ${privacyPolicyLink}

  ${optOutText}: ${optOutLink}`;

  return encode ? encodeURIComponent(body) : body;
};

export { generateInviteEmailSubject, generateInviteEmailBody };
